import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Modal,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util";
import ReactHtmlParser from "react-html-parser";
const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  getReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class EmployeeCommissions extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'EMPLOYEE_COMISSIONS',
      path: ["Home", "Employee Commission Report"],
      links: ["home", "report/commissions"],
      date: new Date(),
      startDate: new Date(),
      range: false,
      disabled: false,
      isLoading: "false",
      csvData: "",
      reportData: "",
      historyPopup: false, 
      payoutHistory: '',
      offerIDs: '',
      merchantIDs: '',
      paymentTermID: '',
      payoutList: '',
      catData: '',
      catID: '',
      merchantTypeID: '',
      otherInfo: 0,
      showValue: '',
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = (date) => {
   
    if (date instanceof Date && !isNaN(date)) {
         this.setState({
          startDate: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDate: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  // onChangeStartDateRange = date => this.setState({ startDateRange: date });

  onChangeStartDateRange = date => {
    
   
    if (date && date[0] instanceof Date && !isNaN(date[0])) {

         this.setState({
          startDateRange: date,
           dobError: false // Reset error state if a valid date is selected
         });
       } 
       else if(date  === null)
       {
        this.setState({
          startDateRange: '',
          dobError: false // Reset error state if a valid date is selected
        });
       }
       else {
         // Handle invalid date (optional)
       //  console.error('Invalid date selected:', selectedDate);
      
         this.setState({
      
        dobError: true // Set error state to indicate invalid date
           
         });
    
       }
     };
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};
    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
        };
      }

      this.props.getReport(formData, 'report/sales-commission');
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    isLoading = "true";
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getReport({startDate: moment(this.state.startDate).format('YYYY-MM-DD')}, 'report/sales-commission');
  }
  componentWillReceiveProps(nextProps) {

    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
      }
    }

    if (this.props.reportData !== nextProps.reportData) {
      if (nextProps.reportData) {
        isLoading = "false";
        this.setState({ otherInfo: nextProps.reportData });
        this.setState({ reportData: nextProps.reportData.data });
        this.handleExport(nextProps.reportData);
      }
    }

    

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }


  }

  handleExport = data => {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }
    let setDate = (this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : moment(this.state.startDate).format('MM/DD/YYYY');
    csvData = [
      [
        'Data up to the date: ' + setDate,
      ],
      [
        'Sales Rep.',
        'Market',
        'Offers Ran',
        'Gross Profits',
        'Fees',
        'Discounts', 
        'Refunds',
        'Affiliates', 
        'Net Profits',
        'Commission',
      ]
    ];

    if(data && data.data){
      data.data.map((data, index) => {
        csvData.push([
          data.salesManagerName,
          data.market,
          data.offersRan,
          data.grossProfits,
          '',
          data.discounts,
          data.refunds,
          data.affiliates,
          data.netProfits,
          '',
        ]);
        if(!isEmpty(data.dealData)){ 
        data.dealData.map((dealData, indexKey) =>
            csvData.push([
              'Offer ID:' + dealData.dealID + ' Offer text:' + ReactHtmlParser(dealData.mainDealText),
              '',
              '',
              dealData.gross_profit,
              '',
              dealData.discounts,
              dealData.refunds,
              dealData.affiliates,
              dealData.net_profit,
              dealData.commission,
            ])
        );
        }

      })
    }

    if(data){
      csvData.push([
        '',
        '',
        data.offers_ran,
        data.gross_profit,
        '',
        data.discounts, 
        data.refunds,
        data.affiliate, 
        data.net_profit,
        data.commission, 
      ])
    }

    this.setState({ csvData: csvData });
  };

  showData = (value) => {
    this.setState({showValue: value});
  }

  hideData = () => {
    this.setState({showValue: ''});
  }

  render() {
    let dateRange;
    if (this.state.range == true && this.state.startDateRange) {
    dateRange = this.state.startDateRange;
    }

    let { reportData } = this.state;
    
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Employee Commission Report</header>
            <div className="panel-body">
              <Row>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : 
             
                    (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                   )
                    
                    }
                  </FormGroup>
                </Col>                
              </Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"employee-commission-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th colSpan="10">Data up to the date: {(this.state.range == true && this.state.startDateRange) ? moment(dateRange[0]).format('MM/DD/YYYY') +' - '+moment(dateRange[1]).format('MM/DD/YYYY') : (this.state.startDate) ? moment(this.state.startDate).format('MM/DD/YYYY') : moment(new Date()).format('MM/DD/YYYY')}</th>
                </tr>
                <tr>
                  <th>Sales Rep.</th>
                  <th>Market</th>
                  <th>Offers Ran</th>
                  <th>Gross Profits</th>
                  <th>Fees</th>
                  <th>Discounts</th> 
                  <th>Refunds</th>
                  <th>Affiliates</th> 
                  <th>Net Profits</th>
                  <th>Commission</th> 
                </tr>
              </thead>
              <tbody>
              	{reportData ?
                  reportData.map((data, index) =>
                    <React.Fragment>
                    <tr key={Math.random()+index}>
                      <td>
                      {(this.state.showValue == index && this.state.showValue !== '') ?
                        <a className="cursor text-danger" onClick={this.hideData}><i className="glyphicon glyphicon-minus-circle"></i></a>
                      :
                        <a className="cursor text-success" onClick={this.showData.bind(this, index)}><i className="glyphicon glyphicon-plus-circle"></i></a>
                      } {data.salesManagerName}</td>
                      <td>{data.market}</td>
                      <td>{data.offersRan}</td>
                      <td>{data.grossProfits}</td>
                      <td></td>
                      <td>{data.discounts}</td>
                      <td>{data.refunds}</td>
                      <td>{data.affiliates}</td>
                      <td>{data.netProfits}</td>
                      <td>{data.commission}</td>
                    </tr>
                    {data.dealData.map((dealData, indexKey) =>
                      <tr key={Math.random()+index+indexKey} style={{display: (this.state.showValue == index && this.state.showValue !== '') ? '' : 'none' }}>
                      <td colSpan="3">Offer ID: {dealData.dealID} <br/> Offer text: {ReactHtmlParser(dealData.mainDealText)}</td>
                      <td>{dealData.gross_profit}</td>
                      <td>{}</td>
                      <td>{dealData.discounts}</td>
                      <td>{dealData.refunds}</td>
                      <td>{dealData.affiliates}</td>
                      <td>{dealData.net_profit}</td>
                      <td>{dealData.commission}</td>
                      </tr>
                      )}
                    </React.Fragment>
                  )
                  :
                  <tr>
                    <td colSpan="10">Data Not Available</td>
                  </tr>
                }
              </tbody>
              {(this.state.otherInfo) &&
              <thead>
              	<tr>
                  <th></th>
                  <th></th>
                  <th>{this.state.otherInfo.offers_ran}</th>
                  <th>{this.state.otherInfo.gross_profit}</th>
                  <th></th>
                  <th>{this.state.otherInfo.discounts}</th> 
                  <th>{this.state.otherInfo.refunds}</th>
                  <th>{this.state.otherInfo.affiliate}</th> 
                  <th>{this.state.otherInfo.net_profit}</th>
                  <th>{this.state.otherInfo.commission}</th> 
                </tr>
              </thead>
          	}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    reportData: state.reportReducer.reportData,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getReport,
  })
)(EmployeeCommissions);


// WEBPACK FOOTER //
// ./src/app/views/admin/reports/EmployeeCommissions.js